import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface StandorteGebaeudeSanierungProps {
    data: any;
    standortSelected: any;
}

export class StandorteGebaeudeSanierung extends React.Component<StandorteGebaeudeSanierungProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.filterOptions = this.filterOptions.bind(this);
         this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
    }
    @lazyInject(TriggerService) private triggerService: TriggerService;

    filterOptions?(options: Array<any>, key: string, data: any) {
        const standort_gebaeude: any = this.props.data.gebaeude || {};
        const { standort_tid } = data;
        const gebaeude: Array<number> = (standort_tid
            ? standort_gebaeude
                .filter((item: any) => (
                    item.standort_tid_orig
                    && +item.standort_tid_orig === standort_tid
                ))
            : standort_gebaeude
        ).map((item: any) => item.tid);

        switch (key) {
            case 'gebaeude_tid':
                return options
                    ? options
                        .filter((item: any) => (
                            item.tid
                            && gebaeude.indexOf(item.tid) > -1
                        ))
                    : options;
            default:
                return options;
        }
    }

    preFilter (data: Array<any>) {
        const { standortSelected } = this.props;
        return standortSelected
            ? data
                .filter((item: any) => (
                    item.standort_tid_orig
                    && +item.standort_tid_orig === standortSelected.tid
                ))
            : data;
    }

    render() {
        const { standortSelected } = this.props;
        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_GEBAEUDE_SANIERUNG}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={'Sanierung erfassen'}
                    formPreset={{ standort_tid: standortSelected.tid }}
                    customFormConfig={{
                        standort_tid: {
                            readonly: true
                        }
                    }}
                    preFilterFunction={this.preFilter}
                    valueFieldSelectDefaultOptions={{ jahr: Moment().year() }}
                    onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_GEBAEUDE_SANIERUNG)}
                    filterOptions={this.filterOptions}
                    validateField={this.validateField}
                />
            </div>
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void) {
        switch (key) {
            case 'kosten':
                if (+value < 0 || +value > 99999999) {
                    return 'Die Kosten (€) müssen im Bereich [0 - 99.999.999] liegen';
                }
                break;
        }
    }
}
